import React from 'react';
import { Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';

const NotificationBell = ({ count, title = 'Notifications', onClick, size = 32 }) => {
    const formatCount = (n) => (n > 99 ? '99+' : n > 9 ? '9+' : String(n));
    const isRTL = typeof document !== 'undefined' ? document.dir === 'rtl' : false;
    const sideProp = isRTL ? 'left' : 'right';

    return (
        <Tooltip title={title}>
            <button
                type="button"
                onClick={onClick}
                aria-label={title}
                style={{
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: size,
                    height: size,
                    padding: 0,
                    background: 'transparent',
                    border: 'none',
                    borderRadius: size / 2,
                    cursor: 'pointer',
                    lineHeight: 0,
                }}
            >
                <BellOutlined style={{ fontSize: 20, color: "var(--npe-text)" }} />

                {count > 0 && (
                    <span
                        style={{
                            position: 'absolute',
                            top: 0,
                            [sideProp]: 17,
                            background: '#f00',
                            color: '#fff',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 700,
                            lineHeight: '16px',
                            height: 16,
                            minWidth: 18,
                            padding: '0 6px',
                            textAlign: 'center',
                            boxShadow: '0 0 0 2px #fff',
                            userSelect: 'none',
                        }}
                    >
            {formatCount(count)}
          </span>
                )}
            </button>
        </Tooltip>
    );
};

export default NotificationBell;
